import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Environment } from '../interfaces';

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('environment');

@NgModule()
export class SharedConfigModule {
  public static register({ environment }: { environment: Environment }): ModuleWithProviders<SharedConfigModule> {
    return { ngModule: SharedConfigModule, providers: [{ provide: ENVIRONMENT, useValue: environment }] };
  }
}
